import React from 'react'

const FacebookIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            fill="none"
            viewBox="0 0 25 26"
        >
            <path
                fill="#fff"
                d="M12.499.502C5.596.502 0 6.1 0 13.002c0 6.237 4.57 11.407 10.546 12.348v-8.735H7.371V13h3.175v-2.754c0-3.135 1.867-4.863 4.72-4.863 1.368 0 2.8.243 2.8.243v3.074h-1.58c-1.55 0-2.035.965-2.035 1.954v2.344h3.464l-.554 3.613h-2.91v8.735c5.976-.936 10.546-6.107 10.546-12.346C24.997 6.1 19.401.502 12.5.502z"
            ></path>
        </svg>
    )
}

export default FacebookIcon
